// extracted by mini-css-extract-plugin
export default {"root":"InfoItem_root__NFMqn","num":"InfoItem_num__UhX8l","list":"InfoItem_list__R-vvD","placeHolderShimmer":"InfoItem_placeHolderShimmer__GOrnx"};